// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgInvoice = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M5.5 1.5H2C1.725 1.5 1.5 1.725 1.5 2V14C1.5 14.275 1.725 14.5 2 14.5H10C10.275 14.5 10.5 14.275 10.5 14V6.5H7.75C6.50625 6.5 5.5 5.49375 5.5 4.25V1.5ZM9.87813 5L7 2.12187V4.25C7 4.66563 7.33437 5 7.75 5H9.87813ZM0 2C0 0.896875 0.896875 0 2 0H6.17188C6.70312 0 7.2125 0.209375 7.5875 0.584375L11.4156 4.41563C11.7906 4.79063 12 5.3 12 5.83125V14C12 15.1031 11.1031 16 10 16H2C0.896875 16 0 15.1031 0 14V2ZM2.5 3.25C2.5 2.83437 2.83438 2.5 3.25 2.5H3.75C4.16562 2.5 4.5 2.83437 4.5 3.25C4.5 3.66562 4.16562 4 3.75 4H3.25C2.83438 4 2.5 3.66562 2.5 3.25ZM2.5 5.75C2.5 5.33437 2.83438 5 3.25 5H3.75C4.16562 5 4.5 5.33437 4.5 5.75C4.5 6.16563 4.16562 6.5 3.75 6.5H3.25C2.83438 6.5 2.5 6.16563 2.5 5.75ZM6.125 7.25C6.46875 7.25 6.75 7.53125 6.75 7.875V8H7C7.34375 8 7.625 8.28125 7.625 8.625C7.625 8.96875 7.34375 9.25 7 9.25H5.64375C5.49688 9.25 5.375 9.36875 5.375 9.51875C5.375 9.64688 5.46562 9.75625 5.59062 9.78125L6.65625 9.99375C7.36562 10.1344 7.875 10.7594 7.875 11.4812C7.875 12.1844 7.39688 12.775 6.75 12.9469V13.1219C6.75 13.4656 6.46875 13.7469 6.125 13.7469C5.78125 13.7469 5.5 13.4656 5.5 13.1219V12.9969H5C4.65625 12.9969 4.375 12.7156 4.375 12.3719C4.375 12.0281 4.65625 11.7469 5 11.7469H6.35625C6.50313 11.7469 6.625 11.6281 6.625 11.4781C6.625 11.35 6.53438 11.2406 6.40938 11.2156L5.34375 11.0062C4.63437 10.8656 4.125 10.2406 4.125 9.51875C4.125 8.72813 4.72812 8.07812 5.5 8.00625V7.875C5.5 7.53125 5.78125 7.25 6.125 7.25Z"
      fill="currentColor"
    />
  </svg>
);
export { SvgInvoice };
